import { LoginHelmetContent } from '../../components/HelmetContent';
import PageContainer from '../../pageLayout/PageContainer';
import Login2Container from './Login2Container';

const Login2Page = () => {
  //자리뽑기-자리뽑기 베타 서비스 이용시 나오는 로그인 페이지
  return (
    <>
      <LoginHelmetContent />
      <PageContainer>
        <Login2Container />
      </PageContainer>
    </>
  );
};

export default Login2Page;
